import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';

import { RecuperarPassComponent } from './recuperar-pass/recuperar-pass.component';
import { AutenticacionService } from '../generico/servicio/autenticacion.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm = this.fb.group({
    usuario: [null, [Validators.required, Validators.email]],
    password: [null, Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private auth : AutenticacionService,
    private router : Router
  ) {
  }
  ngOnInit(): void {
    let user = this.auth.currentUserValue;
    if ( user && user.menu && user.menu.length >0 ){
        this.router.navigate([environment.home]);
    }
  }

  onSubmit() {
    
    let value = this.loginForm.value;
    this.auth.login(value.usuario, value.password); 
  }

  openDialog() {
    const dialogRef = this.dialog.open(RecuperarPassComponent, {
      width: '400px',
    });

  }
}
